export const EXLY_SEGMENT_GET_CONDITIONS = "@EXLY_SEGMENT/GET/CONDITIONS";
export const EXLY_SEGMENT_SET_CONDITIONS = "@EXLY_SEGMENT/SET/CONDITIONS";
export const EXLY_SEGMENT_TOGGLE_COMBINING_FILTER =
  "@EXLY_SEGMENT/TOGGLE_COMBINING_FILTER";

export const EXLY_SEGMENT_UPDATE_CONDITIONS = "@EXLY_SEGMENT/UPDATE/CONDITIONS";
export const EXLY_SEGMENT_SET_NAME = "@EXLY_SEGMENT/SET/NAME";
export const EXLY_SEGMENT_RESET_SEGMENT = "@EXLY_SEGMENT/RESET/SEGMENT";
